const updates = [
  { date: '07-30', title: '《星际穿越2》4K修复版上线，科幻片高清播放专区新增诺兰经典系列', tag: '新片上架' },
  { date: '07-29', title: '动作片在线频道全面升级：新增《疾速追杀》全系列、《敢死队》合集', tag: '频道升级' },
  { date: '07-28', title: '喜剧片免费看周末特辑：沈腾马丽经典作品合集限时专题上线', tag: '专题上线' },
  { date: '07-27', title: '经典电影全集版块扩容：新增上世纪90年代香港电影百部修复资源', tag: '片库扩充' },
  { date: '07-26', title: '天天影院播放线路优化完成，全网加载速度提升40%，极速播放更流畅', tag: '体验优化' },
  { date: '07-25', title: '最新电影大全七月更新报告：本月已上线420+部新片，覆盖全类型', tag: '月度报告' },
  { date: '07-24', title: '移动端观影体验重大升级：自适应码率技术上线，流量更省画质更稳', tag: '技术升级' },
  { date: '07-23', title: '悬疑惊悚片专题周启动：《消失的爱人》《七宗罪》等高分神作限时推荐', tag: '专题活动' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          天天影院的每一次更新，都是为了更好的观影体验
        </p>

        <div className="space-y-0">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 py-4 border-b border-background-200/40 last:border-b-0"
            >
              <div className="flex-shrink-0 text-xs text-foreground-400 font-mono pt-0.5 w-12">
                {item.date}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
              </div>
              <span className="flex-shrink-0 px-2 py-0.5 rounded text-xs bg-accent-500/10 text-accent-500 font-medium whitespace-nowrap">
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}